import PolicyPage from "./PolicyPage";

export default function ShippingPolicy() {
  return (
    <PolicyPage title="Shipping policy" path="/shipping-policy">
      <p>We ship every order from our fulfillment center within 24 business hours of receiving payment.</p>
      <h2>Domestic (US)</h2>
      <ul>
        <li>Standard shipping (3–5 business days): $6.99 flat rate</li>
        <li>Free shipping on all orders over $50</li>
        <li>Expedited (1–2 business days): starts at $14.99, calculated at checkout</li>
      </ul>
      <h2>International</h2>
      <p>We ship to 40+ countries. International rates and estimated delivery times are calculated at checkout based on destination and weight. Buyers are responsible for any customs duties or import taxes.</p>
      <h2>Order tracking</h2>
      <p>Every order includes end-to-end tracking. You will receive a confirmation email with a tracking link as soon as your package leaves the warehouse. You can also track any order on our <a href="/track" className="text-[#0066FF]">Order tracking page</a>.</p>
      <h2>Delays &amp; lost packages</h2>
      <p>If your order takes longer than the estimated delivery window, email <a href="mailto:support@creatormicpro.com" className="text-[#0066FF]">support@creatormicpro.com</a> and we will investigate immediately. Lost packages are replaced free of charge after a carrier investigation is completed.</p>
    </PolicyPage>
  );
}
